import {
  DEFAULT_LOCALE,
  normalizeLocale,
  updateSearchWithLocale,
  type AppLocale,
} from '@gift-i18n';

let pendingLocale: AppLocale | null = null;

export function beginLocaleTransition(
  locale: string | null | undefined,
): AppLocale | null {
  pendingLocale = normalizeLocale(locale) || DEFAULT_LOCALE;
  return pendingLocale;
}

export function getPendingLocaleTransition(): AppLocale | null {
  return pendingLocale;
}

export function matchesPendingLocaleTransition(
  locale: string | null | undefined,
  search: string,
): boolean {
  if (!pendingLocale) return false;
  const normalizedLocale = normalizeLocale(locale) || DEFAULT_LOCALE;
  const expectedSearch = updateSearchWithLocale(search, pendingLocale);
  return normalizedLocale === pendingLocale && search === expectedSearch;
}

export function clearPendingLocaleTransition(): void {
  pendingLocale = null;
}
